import Preferencias from './preferencias';
import Sugerencias from './sugerencias';
import Comunes from './comunes';
import Ranking from './ranking';

export const ApiBuilder = (config) => {
  const api = { byBuilder: true };

  const preferencias = new Preferencias(config.preferencias || config, api);
  const sugerencias = new Sugerencias(config.sugerencias || config, api);
  const comunes = new Comunes(config.comunes || config, api);
  const ranking = new Ranking(config.ranking || config, api);

  return {
    preferencias,
    sugerencias,
    comunes,
    ranking,
    execute: () => preferencias.execute()
  };
};

export default ApiBuilder;



// WEBPACK FOOTER //
// ./~/@ln/personalizacion/api.js